<template>
    <div>
        <Field v-model="content" :field="field" @error="error" v-bind="$attrs" :extendErrors="errors" :store="store"/>
        <slot></slot>
    </div>
</template>

<script>
import IdentityFields from '../identityFields/IdentityFields'
import _ from 'lodash'

export default {
    name: 'Input',
    components: {
        Field: IdentityFields
    },
    props: {
        label: {
            type: String
        },
        value: {
            type: String | Number
        },
        name: {
            type: String
        },
        rules: {
            type: Object
        },
        type: {
            type: String,
            default: 'text'
        },
        description: {
            type: String,
        },
        errors: {
            type: Array,
            default: () => []
        },
        store: {
            type: Object
        }
    },
    data: function() {
        return {
            field: {
                type: "text_i18n",
                module: "input",
                key: this.name,
                name: this.label,
                description: this.description,
                constraints: this.constraints
            }
        }
    },
    computed: {
        constraints() {
            return this.rules || {}
        },

        content: {
            get() {
                let valObj = {}
                valObj[this.field.key] = this.value

                return valObj
            },

            set(val) {
                if (this.constraints.expression) {
                    this.errors = this.constraints.expression(val)
                    this.error({
                        field: this.name,
                        error: this.errors.length > 0
                    })
                }

                this.$emit('input', val[this.field.key])
            }
        }
    },
    methods: {
        error(errors) {
            this.$emit('error', errors)
        }
    }
}
</script>